import { cx } from 'cva';
import {
  type FunctionComponent,
  type MouseEventHandler,
  type Ref,
} from 'react';
import { BoldIcon } from '../../icons/BoldIcon';
import { CodeSnippetIcon } from '../../icons/CodeSnippetIcon';
import { EmojiIcon } from '../../icons/EmojiIcon';
import { ItalicsIcon } from '../../icons/ItalicsIcon';
import { StrikeThroughIcon } from '../../icons/StrikeThroughIcon';
import styles from './MessageInputControlsButton.module.css';

export type MessageInputFormattingType =
  | 'bold'
  | 'code'
  | 'italics'
  | 'strikethrough';

export type MessageInputControlType = 'emoji' | MessageInputFormattingType;

const ControlsIcons: Record<MessageInputControlType, React.ComponentType> = {
  bold: BoldIcon,
  code: CodeSnippetIcon,
  emoji: EmojiIcon,
  italics: ItalicsIcon,
  strikethrough: StrikeThroughIcon,
};

export type MessageInputControlButtonProps = {
  active?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  ref?: Ref<HTMLButtonElement>;
  type: MessageInputControlType;
};

export const MessageInputControlButton: FunctionComponent<
  MessageInputControlButtonProps
> = ({ active, onClick, ref, type }) => {
  const Icon = ControlsIcons[type];

  return (
    <button
      className={cx(styles.root, type, { active })}
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <Icon />
    </button>
  );
};
